import { call, put, takeLatest } from 'redux-saga/effects';
import Code from '../../api/code';
import { actionTypes, getCodesSuccess } from '../actions/code';

function* getCodes() {
  try {
    const result = yield call(() => Code.getCodes());
    yield put(getCodesSuccess(result));
  } catch (error) {
    console.log(error);
  }
}

export default function* codeSaga() {
  yield takeLatest(actionTypes.GET_CODES, getCodes);
}
